import { _request } from "../utils/request"
import { sessionStorage } from '../utils/storage'
import { USER_INFO } from '../utils/enum'

/**
 * @description: 获取素材列表
 * @param {object} payload
 * @return {promise}
 */
export const fetchMaterialList = payload => {
  return _request('/medias', {
    method: 'post',
    data: {
      ...payload,
      '_token': sessionStorage.getItem(USER_INFO).data || ''
    },
    headers: {
      'X-CSRF-TOKEN': sessionStorage.isExistItem(USER_INFO) ? sessionStorage.getItem(USER_INFO).data : ''
    }
   })
}

/**
 * @description: 获取下载信息
 * @param {object} payload
 * @return {promise}
 */
export const fetchDownloadInfo = payload => {
  return  _request('/media_download', { 
    method: 'post', 
    data: {
      ...payload,
      '_token': sessionStorage.getItem(USER_INFO).data || ''
    },
    headers: {
      'X-CSRF-TOKEN': sessionStorage.isExistItem(USER_INFO) ? sessionStorage.getItem(USER_INFO).data : ''
    }
  })
}

/**
 * @description: 获取图片验证码
 * @param {object} payload
 * @return {promise}
 */
export const fetchVerifyCode = payload => {
  return  _request('/verification/create', { 
    method: 'get', 
    data: payload,
    headers: {
      'X-CSRF-TOKEN': sessionStorage.isExistItem(USER_INFO) ? sessionStorage.getItem(USER_INFO).data : ''
    }
  })
}

/**
 * @description: 图片验证码坐标校验
 * @param {object} payload
 * @return {promise}
 */
export const fetchCheckVerifyCode = payload => {
  return  _request('/verification/check', { 
    method: 'post', 
    data: {
      ...payload,
      '_token': sessionStorage.getItem(USER_INFO).data || ''
    },
    headers: {
      'X-CSRF-TOKEN': sessionStorage.isExistItem(USER_INFO) ? sessionStorage.getItem(USER_INFO).data : ''
    }
  })
}




// WEBPACK FOOTER //
// ./pc/yiqijian-video/api/material.js